import React, { useEffect, useState } from 'react';
import style from './audio.module.css';
import Waveform from './waveForm';
import { FaPlay, FaPause } from "react-icons/fa6";
import parse from 'html-react-parser';
import audioManager from './audioManager';
import { useSelector } from 'react-redux';

const Audio = ({ src, onPlay, message, messageObj }) => {
  const { messages } = useSelector((state) => ({
    messages: state.messages.messages,
  }));
  const [isPlay, setIsPlay] = useState();

  useEffect(() => {
    const audioInstance = { setIsPlay };
    audioManager.registerAudio(audioInstance);

    return () => {
      audioManager.unregisterAudio(audioInstance);
    };
  }, []);

  useEffect(() => {
    if (messages && messages[messages.length-2]?.props?.message?.type === "audio") {
      audioManager.pauseAllOthers(setIsPlay);
    }
  }, [messages]);

  const handlePlayPause = () => {
    setIsPlay((prev) => {
      const newState = !prev;

      // If newState is "play", pause all others
      if (newState) {
        audioManager.pauseAllOthers(setIsPlay);
      }
      return newState;
    });
  };

  return (
    <div className={`rcw-message-content ${style.audiocontainer}`}>
      <div className={style.container}>
        <button className='play-pause-button' onClick={handlePlayPause}>{!isPlay ? <FaPlay color='#383737' /> : <FaPause color='#383737' />}</button>
        <Waveform url={src} isPlay={isPlay} setPlay={setIsPlay} message={messageObj}/>
      </div>
      {message && <p className={style.caption}>{parse(message)}</p>}
    </div>
  );
};

export default Audio;
